import { useCurrentAccount } from '@application/api';
import { useConfirmModal } from '@application/utils';
import { Analytics } from '@application/utils/analytics';
import type { MatchData } from '@presentation/components';
import { useCallback, useEffect } from 'react';
import { useCheckoutApplication } from './api/useCheckoutApplication';

export const useCheckoutModal = (applicationId: number | undefined, match: MatchData) => {
  const { modal, confirmHandler, confirmedShow } = useConfirmModal();
  const { checkoutApplicationAndRedirect, checkoutApplicationLoading } = useCheckoutApplication();
  const { currentAccountCheckoutPriceValue } = useCurrentAccount();

  const checkoutApplicationClickHandler = useCallback(async () => {
    if (!(await confirmedShow())) return;
    if (!applicationId) throw new Error();

    Analytics.sendBeginCheckoutEvent(currentAccountCheckoutPriceValue);

    return checkoutApplicationAndRedirect(applicationId);
  }, [
    applicationId,
    checkoutApplicationAndRedirect,
    confirmedShow,
    currentAccountCheckoutPriceValue,
  ]);

  useEffect(() => {
    if (!modal.open) {
      return;
    }

    Analytics.sendOpenCheckoutModalEvent(currentAccountCheckoutPriceValue);
  }, [currentAccountCheckoutPriceValue, modal.open]);

  return {
    checkoutApplicationLoading,
    checkoutApplicationClickHandler,
    checkoutApplicationModalProps: {
      modal,
      match,
      onConfirm: confirmHandler,
    },
  };
};
